import { NgModule } from '@angular/core';

import { IndexOfPipe } from './index-of.pipe';

@NgModule({
    imports: [],
    declarations: [IndexOfPipe],
    exports: [IndexOfPipe],
})
export class IndexOfPipeModule {}
